import { AlertTriangle, Route, FileText, Settings } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { useAuth, LoadingSpinner } from '@/shared';
import { JourneysPage } from '@/features/journeys';
import { OrdersPage } from '@/features/orders';
import { RulesPage } from '@/features/rules';
export function HomePage() {
  const { isLoading, isAuthenticated, shop } = useAuth();

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!isAuthenticated || !shop) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 max-w-md">
          <div className="flex gap-3">
            <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0" />
            <div>
              <h3 className="font-medium text-amber-800">Authentication Required</h3>
              <p className="mt-1 text-sm text-amber-700">
                Please authenticate to access the attribution dashboard.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="px-8 md:px-12 lg:px-16 py-6">
        <Tabs defaultValue="journeys" className="space-y-6">
          <TabsList className="grid w-full grid-cols-3 lg:w-auto lg:inline-flex">
            <TabsTrigger value="journeys" className="gap-2">
              <Route className="h-4 w-4" />
              <span className="hidden sm:inline">Customer Journeys</span>
              <span className="sm:hidden">Journeys</span>
            </TabsTrigger>
            <TabsTrigger value="orders" className="gap-2">
              <FileText className="h-4 w-4" />
              <span className="hidden sm:inline">Attribution Log</span>
              <span className="sm:hidden">Orders</span>
            </TabsTrigger>
            <TabsTrigger value="rules" className="gap-2">
              <Settings className="h-4 w-4" />
              <span className="hidden sm:inline">Rules Configuration</span>
              <span className="sm:hidden">Rules</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="journeys">
            <JourneysPage />
          </TabsContent>

          <TabsContent value="orders">
            <OrdersPage />
          </TabsContent>

          <TabsContent value="rules">
            <RulesPage />
          </TabsContent>

        </Tabs>
      </div>
    </div>
  );
}
